import React, { useEffect, useState } from "react";
import { FormControlLabel, Grid, Checkbox, Button, Card } from "@mui/material";
import { TCLabel } from "components/TopCourtComponents/Label/TopCourtLabel";
import { TCInput, TCSelect, TCSelectStyle } from "components/TopCourtComponents/Input/TopCourtInput";

import { dayOptions, timeOptions } from "constant/constant"
import DateRangeInput from "components/TopCourtComponents/Input/DateRangeFilter";
import { getCourts, getCourtTypes, getSportCourtTypes } from "services/placeServices";
import { courtTypeObj } from "constant/constant";
import AsyncSelect from "react-select/async";
import { getPlayers } from "services/playerServices";
import { getAddOnCoach, getServices } from "services/addonServices";
import { getDateRangeFromSchedule, groupSession } from "./helper";
import TCAccordion from "components/TopCourtComponents/TCAccordion";
import moment from "moment";
import { BookingScheduleList } from "./schedule";
import { loadBookingforClasses } from "services/classService";
import { getParamsFromURL } from "helper/Params";

const initJoi = {
    courtTypeInfo: null,
    courtInfo: null,
    startDate: null,
    endDate: null,
    startHours: null,
    endHours: null,
    // coachInfo: null
}

const initForm = {
    ...initJoi,
    offDays: null,
    coachInfo: null,
    includeBallboy: false,
}

const classType = {
    DYNAMIC: 'dynamic',
    FIXED: 'fixed',
    SELECT_SESSION_TIME: 'select_session_time',
};

const allowMultipleCourt = false

function ClassScheduleInfo({
    setClassCourt,
    classId,
    formData,
    placeId,
}) {

    const [courtTypeOption, setCourtType] = useState([])
    const [ballboy, setBallboy] = useState([])
    const [typeInfo, setTypeInfo] = useState("fixed")
    const [courtsOptions, setCourtsOptions] = useState([])
    const [form, setForm] = useState(initForm)
    const [allowUpdate, setAllowUpdate] = useState(false)
    const [JoiForm, setJoiForm] = useState(initJoi)
    const [bookingList, setBookingList] = useState([])
    const [currentClass, setCurrentClass] = useState([])
    const [reload, setReload] = useState(Date.now())

    const loadCourtType = async (place) => {
        let placeId = place ? place.value : ''
        let { data, error } = await getSportCourtTypes({ placeId })
        if (error) { console.log(error) }
        if (data) {
            let courtType = []
            for (let i = 0; i < data.length; i++) {
                courtType.push({
                    _id: data[i]._id,
                    label: data[i].name,
                    value: data[i].courtType
                })
            }
            setCourtType(courtType)
        }
    }

    useEffect(() => {
        onChangePlaceSetInit(placeId)
        loadCourtType(placeId)
        loadBallboyInfo(placeId)
        loadClassBooking(placeId)
    }, [placeId])


    useEffect(() => {
        setJoiForm({
            courtTypeInfo: form.courtTypeInfo ? null : '*',
            courtInfo: form.courtInfo ? null : '*',
            startDate: form.startDate ? null : '*',
            endDate: form.endDate ? null : '*',
            startHours: form.startHours ? null : '*',
            endHours: form.endHours ? null : '*',
            hours: !form.hours && typeInfo === classType.SELECT_SESSION_TIME ? '*' : null
            // coachInfo: form.coachInfo ? null : '*'
        })
    }, [form])

    function onChangePlaceSetInit(place) {
        if (place) {
            setForm(initForm)
            setAllowUpdate(false)
            setJoiForm(initJoi)
            setTypeInfo('fixed')
            setCourtsOptions([])
            setBallboy([])
        }
    }

    useEffect(() => {
        if (formData && !allowUpdate) {
            setTypeInfo(formData.courtSelection || formData.classSchedule?.courtSelection)
            let orderItems = []
            let offDays = []
            for (let i = 0; i < courtTypeOption.length; i++) {
                let exist = formData.classSchedule.courtType?.indexOf(courtTypeOption[i].value)
                if (exist >= 0) {
                    orderItems.push(courtTypeOption[i])
                }
            }
            for (let i = 0; i < dayOptions.length; i++) {
                let exist = formData.classSchedule.offDays ? formData.classSchedule.offDays.indexOf(dayOptions[i].value) : -1
                if (exist >= 0) {
                    offDays.push(dayOptions[i])
                }
            }
            let endHours = null
            let nextHours = false
            for (let i = 0; i < timeOptions.length; i++) {
                if (nextHours) { endHours = timeOptions[i]; break; }
                if (timeOptions[i].value == formData.classEndHours) { nextHours = true }
            }
            // setForm({
            //     courtTypeInfo: orderItems,
            //     courtInfo: formData.classSchedule.court ? {
            //         label: `${courtTypeObj[formData.classSchedule.court.courtType]} ${formData.classSchedule.court.name}`,
            //         value: formData.classSchedule.court._id
            //     }
            //         : null,
            //     startDate: formData.classSchedule.startClassDate,
            //     endDate: formData.classSchedule.endClassDate,
            //     startHours: formData.classStartHours ? { label: formData.classStartHours, value: formData.classStartHours } : null,
            //     endHours: formData.classEndHours ? endHours : null,
            //     offDays: offDays,
            //     coachInfo: formData.coaches,
            //     includeBallboy: formData.includeBallboy || false,
            //     priorityBallboy: formData.priorityBallboy || null
            // })
            let scheduleInfo = normalizeScheduleInfo(formData.scheduleInfo || [])
            let scheduleHours = []

            if (scheduleInfo && scheduleInfo.length > 0) {
                for (let i = 0; i < scheduleInfo.length; i++) {
                    let day = scheduleInfo[i]

                    if (day.courtsInfo && day.courtsInfo.length > 0) {
                        for (let j = 0; j < day.courtsInfo.length; j++) {
                            let courtInfo = day.courtsInfo[j]

                            if (courtInfo.hours && courtInfo.hours.length > 0) {
                                scheduleHours = scheduleHours.concat(courtInfo.hours)
                            }
                        }
                    }

                    if (day.hours && day.hours.length > 0) {
                        scheduleHours = scheduleHours.concat(day.hours)
                    }
                }
            }

            scheduleHours = [...new Set(scheduleHours)]

            const firstSchedule = scheduleInfo?.[0] || null
            const firstCourtInfo = firstSchedule?.courtsInfo?.[0] || null

            setForm({
                courtTypeInfo: orderItems,
                courtInfo: formData.classSchedule.court ? {
                    label: `${courtTypeObj[formData.classSchedule.court.courtType]} ${formData.classSchedule.court.name}`,
                    value: formData.classSchedule.court._id
                }
                    : null,
                startDate: formData.classSchedule.startClassDate,
                endDate: formData.classSchedule.endClassDate,
                startHours: formData.classStartHours ? { label: formData.classStartHours, value: formData.classStartHours } : null,
                endHours: formData.classEndHours ? endHours : null,
                offDays: offDays,
                coachInfo: formData.coaches,
                includeBallboy: formData.includeBallboy || false,
                priorityBallboy: formData.priorityBallboy || null,

                // add this for default selected schedule
                scheduleInfo: scheduleInfo,
                hours: scheduleHours,
                courts: scheduleInfo.map(d => d.courts),
                courtsInfo: scheduleInfo,
                court: firstCourtInfo?._id || null,
                date: firstSchedule?.date || null,
            })
        }
        if (courtTypeOption.length > 0) { setAllowUpdate(true) }
        // setAllowUpdate(true)
    }, [formData, courtTypeOption])

    useEffect(() => {
        if (form.courtTypeInfo) {
            loadCourtInfo(placeId)
        }
    }, [form.courtTypeInfo])

    useEffect(() => {
        if (allowUpdate == true) {
            setClassCourt({
                courtSelection: typeInfo,
                courtType: form.courtTypeInfo,
                court: form.courtInfo,
                startClassDate: form.startDate,
                endClassDate: form.endDate,
                offDays: form.offDays,
                classStartHours: form.startHours ? form.startHours.value : '',
                classEndHours: form.endHours ? form.endHours.value : '',
                coachInfo: form.coachInfo ? form.coachInfo : null,
                includeBallboy: form.includeBallboy,
                priorityBallboy: form.priorityBallboy,
                //
                ...(typeInfo === classType.SELECT_SESSION_TIME ? {
                    courts: form.scheduleInfo,
                    scheduleInfo: form.scheduleInfo,
                    hours: form.hours
                } : {})
            })
        }
    }, [form])

    const loadCourtInfo = async (place) => {
        if (typeInfo == "dynamic") { return [] }
        let placeId = place ? place.value : ''
        let { data, error } = await getCourts(placeId)
        if (error) { console.log(error) }
        if (data) {
            let courts = []
            console.log('debug ', form.courtTypeInfo)
            for (let i = 0; i < data.courts.length; i++) {
                if (form.courtTypeInfo.length > 0) {
                    if (data.courts[i].courtType == form.courtTypeInfo[0].value) {
                        courts.push({
                            label: `${courtTypeObj[data.courts[i].courtType]} ${data.courts[i].name}`,
                            value: data.courts[i]._id
                        })
                    }
                }
            }
            setCourtsOptions(courts)
        }
    }

    const loadBallboyInfo = async (place) => {
        let placeId = place ? place.value : ''
        let { data, error } = await getServices('ball_boy', placeId);
        if (data) {
            setBallboy(data.map(v => {
                return {
                    label: v.name,
                    value: v._id,
                    data: v
                }
            }))
        }
    }

    const getBallBoyInfo = (bb) => {
        if (!bb || !ballboy) { return; }
        return ballboy.find(v => v.value.toString() === bb.toString())
    }

    const loadTimeOptions = (isStartHours, isEndHours) => {
        let newHours = []
        let startHours = "06:00"
        let allowAddHours = false
        if (isStartHours) {
            for (let i = 0; i < timeOptions.length; i++) {
                if (timeOptions[i].value == startHours) { allowAddHours = true }
                if (allowAddHours) { newHours.push(timeOptions[i]) }
            }
            newHours.pop()
            return newHours
        }
        let formStartHours = form.startHours
        if (isEndHours && formStartHours) {
            for (let i = 0; i < timeOptions.length; i++) {
                if (allowAddHours) { newHours.push(timeOptions[i]) }
                if (timeOptions[i].value == formStartHours.value) { allowAddHours = true }
            }
            return newHours
        }
    }

    const loadUserOption = async (input) => {
        if (input.length < 3) {
            return
        }
        try {
            let { data, error } = await getAddOnCoach(input);
            if (error) throw error
            if (data) {
                if (data.length <= 0) return
                return data.map(value => {
                    return {
                        label: value.name,
                        value: value._id
                    }
                })
            }
        } catch (error) {
            console.log(error.message || error)
            return ([])
        }
    }

    const onChange = (e) => {
        setForm(prev => ({
            ...prev,
            ...e,
        }))
    }

    const emit = (scheduleInfo) => {
        const { startDate, endDate } = getDateRangeFromSchedule(scheduleInfo);

        // flatten all courtsInfo
        const courtsInfo = scheduleInfo.flatMap(d => d.courtsInfo || []);

        // merge ALL hours from ALL courtsInfo
        const hours = [
            ...new Set(
                courtsInfo.flatMap(ci => ci.hours || [])
            )
        ];

        const firstCourt = scheduleInfo?.[0]?.courtsInfo?.[0];

        onChange({
            court: firstCourt?._id || null,
            date: scheduleInfo?.[0]?.date || null,
            hours: hours,

            courts: scheduleInfo.map(d => d.courts),
            courtsInfo: scheduleInfo,

            scheduleInfo,
            startDate,
            endDate
        });

        setReload(Date.now());
    };

    const checkCourtInfo = (e, v) => {
        let scheduleInfo = [...(form.scheduleInfo || [])];
        const { date, hours } = e;

        let dayIndex = scheduleInfo.findIndex(d => d.date === date);

        // ➜ CREATE NEW DATE ENTRY
        if (dayIndex < 0) {
            if (hours.length === 0) return;

            scheduleInfo.push({
                date,
                courts: [v._id],
                courtsInfo: [{
                    _id: v._id,
                    name: v.name,
                    courtType: v.courtType,
                    hours
                }]
            });

            return emit(scheduleInfo);
        }

        let day = scheduleInfo[dayIndex];

        let courtIndex = day.courts.indexOf(v._id);
        let infoIndex = day.courtsInfo.findIndex(c => c._id === v._id);

        // ➜ REMOVE HOURS (delete court)
        if (hours.length === 0) {
            if (courtIndex >= 0) {
                day.courts.splice(courtIndex, 1);
            }

            if (infoIndex >= 0) {
                day.courtsInfo.splice(infoIndex, 1);
            }

            if (day.courts.length === 0) {
                scheduleInfo.splice(dayIndex, 1);
            }

            return emit(scheduleInfo);
        }

        // ➜ SINGLE COURT MODE (replace everything)
        if (!allowMultipleCourt) {
            day.courts = [v._id];
            day.courtsInfo = [{
                _id: v._id,
                name: v.name,
                courtType: v.courtType,
                hours
            }];
        }
        // ➜ MULTI COURT MODE
        else {
            if (courtIndex < 0) {
                day.courts.push(v._id);
                day.courtsInfo.push({
                    _id: v._id,
                    name: v.name,
                    courtType: v.courtType,
                    hours
                });
            } else {
                day.courtsInfo[infoIndex].hours = hours;
            }
        }

        emit(scheduleInfo);
    };

    const loadClassBooking = async (placeId) => {
        try {
            const placeIds = placeId ? placeId.value : null
            console.log('params', placeIds)
            let { params } = getParamsFromURL(window);
            // setLoading(true)
            let { data, error } = await loadBookingforClasses(params || '', '', placeIds)
            if (data) {
                let newBookings = []
                newBookings = groupSession(data.orders)
                setBookingList(newBookings)
                setCurrentClass(data.classOrder)
            }
            // setLoading(false)
        } catch (error) {
            // setLoading(false)
            console.log(error)
        }
    }

    return (
        <Grid container xs={12} pt={0}>
            <Grid item container mb={1} xs={6}>
                <Grid item>
                    <FormControlLabel control={<Checkbox
                        disabled={classId}
                        checked={typeInfo == "fixed"}
                        onChange={() => {
                            setTypeInfo("fixed")
                            setForm(initForm)
                        }}
                    />} label={<TCLabel bold>Fixed</TCLabel>} />
                </Grid>
                <Grid item>
                    <FormControlLabel control={<Checkbox
                        disabled={classId}
                        checked={typeInfo == "dynamic"}
                        onChange={() => {
                            setTypeInfo("dynamic")
                            setForm(initForm)
                        }}
                    />} label={<TCLabel bold>Dynamic</TCLabel>} />
                </Grid>
                <Grid item>
                    <FormControlLabel control={<Checkbox
                        disabled={classId}
                        checked={typeInfo == classType.SELECT_SESSION_TIME}
                        onChange={() => {
                            setTypeInfo(classType.SELECT_SESSION_TIME)
                            setForm(initForm)
                        }}
                    />} label={<TCLabel bold>Select Session Time</TCLabel>} />
                </Grid>
                {/* <Grid item xs alignContent={"center"}>
                    <TCLabel>{typeInfo == "fixed" ? "Fixed court will only use selected court" : 
                    "Dynamic court will get available court for the class"}</TCLabel>
                </Grid> */}
            </Grid>
            <Grid item container mb={1} xs={6}>
                <Grid item>
                    <FormControlLabel control={<Checkbox
                        // disabled={classId}
                        checked={form.includeBallboy}
                        onChange={() => {
                            setForm(prev => ({
                                ...prev,
                                includeBallboy: !form.includeBallboy
                            }))
                        }}
                    />} label={<TCLabel>Ballboy (Random Pick)</TCLabel>} />
                </Grid>
            </Grid>
            {
                form.includeBallboy &&
                <Grid mb={1} xs={12} md={4}>
                    <TCSelect
                        isClearable={true}
                        label={"Ballboy Priority"}
                        value={getBallBoyInfo(form.priorityBallboy)}
                        options={ballboy}
                        onChange={(e) => {
                            setForm(prev => ({
                                ...prev,
                                priorityBallboy: e
                            }))
                        }}
                    />
                </Grid>
            }
            {/* Fixed */}
            {
                typeInfo == "fixed" &&
                <Grid item container xs={12} mb={1}>
                    <Grid item container xs={12} spacing={2}>
                        <Grid item xs={12} md={6}>
                            <Grid container alignItems={'flex-end'} spacing={1}>
                                <Grid item>
                                    <TCLabel>Court Type</TCLabel>
                                </Grid>
                                <Grid item sx={{ pt: '0px !important', pl: '2px !important' }}>
                                    {JoiForm.courtTypeInfo ?
                                        <TCLabel style={{ fontSize: 11, color: '#f44336' }}>{JoiForm.courtTypeInfo}</TCLabel>
                                        : ''
                                    }
                                </Grid>
                            </Grid>
                            <TCSelect showAlert={JoiForm && JoiForm.courtType}
                                options={courtTypeOption}
                                disabled={classId}
                                value={form.courtTypeInfo ? form.courtTypeInfo[0] : null}
                                // isMulti={true}
                                onChange={(e) => {
                                    onChange({ courtTypeInfo: [e], courtInfo: null })
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <Grid container alignItems={'flex-end'} spacing={1}>
                                <Grid item>
                                    <TCLabel>Court</TCLabel>
                                </Grid>
                                <Grid item sx={{ pt: '0px !important', pl: '2px !important' }}>
                                    {JoiForm.courtInfo ?
                                        <TCLabel style={{ fontSize: 11, color: '#f44336' }}>{JoiForm.courtInfo}</TCLabel>
                                        : ''
                                    }
                                </Grid>
                            </Grid>
                            <TCSelect
                                options={courtsOptions}
                                disabled={classId}
                                value={form.courtInfo}
                                onChange={(e) => {
                                    onChange({ courtInfo: e })
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <DateRangeInput
                                disabledVariable
                                showLabel={true}
                                showAlert={JoiForm.startDate || JoiForm.endDate}
                                disabledStart={classId}
                                startDate={form.startDate}
                                startDateMinDate={new Date()}
                                endDate={form.endDate}
                                endDateMinDate={form.startDate ? form.startDate : new Date()}
                                onChangeStartDate={(e) => onChange({ startDate: e, endDate: null })}
                                onChangeEndDate={(e) => onChange({ endDate: e })}
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <Grid container alignItems={'flex-end'} spacing={1}>
                                <Grid item>
                                    <TCLabel>Hours</TCLabel>
                                </Grid>
                                <Grid item sx={{ pt: '0px !important', pl: '2px !important' }}>
                                    {JoiForm.startHours || JoiForm.endHours ?
                                        <TCLabel style={{ fontSize: 11, color: '#f44336' }}>{JoiForm.startHours || JoiForm.endHours}</TCLabel>
                                        : ''
                                    }
                                </Grid>
                            </Grid>
                            <Grid item container spacing={1}>
                                <Grid item xs>
                                    <TCSelect
                                        options={loadTimeOptions(true, false)}
                                        disabled={classId}
                                        value={form.startHours}
                                        onChange={(e) => {
                                            onChange({ startHours: e, endHours: null })
                                        }}
                                    />
                                </Grid>
                                <Grid item xs>
                                    <TCSelect
                                        options={loadTimeOptions(false, true)}
                                        disabled={classId}
                                        value={form.endHours}
                                        onChange={(e) => {
                                            onChange({ endHours: e })
                                        }}
                                    />
                                </Grid>
                            </Grid>
                            {/* <TCSelect
                                options={courtTypeOption}
                            /> */}
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <TCLabel>Off Days</TCLabel>
                            <Grid item xs>
                                <TCSelect
                                    isMulti={true}
                                    disabled={classId}
                                    options={dayOptions}
                                    value={form.offDays}
                                    onChange={(e) => {
                                        onChange({ offDays: e })
                                    }}
                                />
                            </Grid>
                        </Grid>
                        {/* <Grid item xs={12} textAlign={"right"}>
                            <Button variant="contained" onClick={() => {
                                console.log(form)
                            }}>
                                Add
                            </Button>
                        </Grid> */}
                    </Grid>
                </Grid>
            }
            {/* Dynamic */}
            {
                typeInfo == "dynamic" &&
                <Grid item container xs={12} mb={1}>
                    <Grid item container xs={12} spacing={2}>
                        <Grid item xs={12} md={6}>
                            <Grid container alignItems={'flex-end'} spacing={1}>
                                <Grid item>
                                    <TCLabel>Court Type</TCLabel>
                                </Grid>
                                <Grid item sx={{ pt: '0px !important', pl: '2px !important' }}>
                                    {JoiForm.courtTypeInfo ?
                                        <TCLabel style={{ fontSize: 11, color: '#f44336' }}>{JoiForm.courtTypeInfo}</TCLabel>
                                        : ''
                                    }
                                </Grid>
                            </Grid>
                            <TCSelect
                                options={courtTypeOption}
                                value={form.courtTypeInfo}
                                disabled={classId}
                                isMulti={true}
                                onChange={(e) => {
                                    onChange({ courtTypeInfo: e })
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <Grid container alignItems={'flex-end'} spacing={1}>
                                <Grid item>
                                    <TCLabel>Coach</TCLabel>
                                </Grid>
                                <Grid item sx={{ pt: '0px !important', pl: '2px !important' }}>
                                    {/* {JoiForm.coachInfo ?
                                    <TCLabel style={{ fontSize: 11, color: '#f44336' }}>{JoiForm.coachInfo}</TCLabel>
                                    :''
                                } */}
                                </Grid>
                            </Grid>
                            <AsyncSelect
                                styles={{
                                    menuPortal: base => ({ ...base, zIndex: 9999 }),
                                    ...TCSelectStyle
                                }}
                                placeholder={'Select Coach'}
                                isClearable
                                async
                                defaultOptions
                                loadOptions={loadUserOption}
                                isMulti={true}
                                value={form.coachInfo} onChange={(e) => { onChange({ coachInfo: e }) }}
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <DateRangeInput
                                disabledVariable
                                showLabel={true}
                                showAlert={JoiForm.startDate || JoiForm.endDate}
                                disabledStart={classId}
                                startDate={form.startDate}
                                startDateMinDate={new Date()}
                                endDate={form.endDate}
                                endDateMinDate={form.startDate ? form.startDate : new Date()}
                                onChangeStartDate={(e) => onChange({ startDate: e, endDate: null })}
                                onChangeEndDate={(e) => onChange({ endDate: e })}
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <Grid container alignItems={'flex-end'} spacing={1}>
                                <Grid item>
                                    <TCLabel>Hours</TCLabel>
                                </Grid>
                                <Grid item sx={{ pt: '0px !important', pl: '2px !important' }}>
                                    {JoiForm.startHours || JoiForm.endHours ?
                                        <TCLabel style={{ fontSize: 11, color: '#f44336' }}>{JoiForm.startHours || JoiForm.endHours}</TCLabel>
                                        : ''
                                    }
                                </Grid>
                            </Grid>
                            <Grid item container spacing={1}>
                                <Grid item xs>
                                    <TCSelect
                                        disabled={classId}
                                        options={loadTimeOptions(true, false)}
                                        value={form.startHours}
                                        onChange={(e) => {
                                            onChange({ startHours: e, endHours: null })
                                        }}
                                    />
                                </Grid>
                                <Grid item xs>
                                    <TCSelect
                                        disabled={classId}
                                        options={loadTimeOptions(false, true)}
                                        value={form.endHours}
                                        onChange={(e) => {
                                            onChange({ endHours: e })
                                        }}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <TCLabel>Off Days</TCLabel>
                            <Grid item xs>
                                <TCSelect
                                    isMulti={true}
                                    disabled={classId}
                                    options={dayOptions}
                                    value={form.offDays}
                                    onChange={(e) => {
                                        onChange({ offDays: e })
                                    }}
                                />
                            </Grid>
                        </Grid>
                        {/* <Grid item xs={12} textAlign={"right"}>
                            <Button variant="contained" onClick={() => {
                                console.log(form)
                            }}>
                                Add
                            </Button>
                        </Grid> */}
                    </Grid>
                </Grid>
            }
            {/* Select Session Time */}
            {
                typeInfo == classType.SELECT_SESSION_TIME &&
                <Grid item container p={1} pt={0}>
                    {bookingList.length > 0 ?
                        <Grid item container>
                            <Grid item>
                                <TCLabel>Select Event Session Time</TCLabel>
                            </Grid>
                            <Grid item>
                                <TCLabel style={{ color: 'red' }}>{JoiForm.hours}</TCLabel>
                            </Grid>
                            <Grid xs={12}>
                                {
                                    bookingList.map(value => {
                                        return (
                                            <Card item xs={12} mb={1}>
                                                <TCAccordion title={
                                                    <TCLabel>
                                                        <div>
                                                            {moment(value.date).format("DD/MM/YYYY")}
                                                            <div>{value.eventName}</div>
                                                        </div>
                                                    </TCLabel>
                                                }>
                                                    {
                                                        value.courts.sort((a, b) => a.index - b.index).map(v => {
                                                            return (
                                                                <BookingScheduleList data={{
                                                                    ...v, date: value.date,
                                                                    selected: form.scheduleInfo,
                                                                    selectedHours: form.hours
                                                                }}
                                                                    reload={reload}
                                                                    court={form.court}
                                                                    date={form.date}
                                                                    checkTime={false}
                                                                    allowMultipleCourt={false}
                                                                    allowMultiple={true}
                                                                    disableSelectionClass={{
                                                                        currentClass: currentClass,
                                                                        court: v._id,
                                                                        date: value.date
                                                                    }}
                                                                    onChangeSchedule={(e) => {
                                                                        checkCourtInfo(e, v)
                                                                    }} />
                                                            )
                                                        })
                                                    }
                                                </TCAccordion>
                                            </Card>
                                        )
                                    })}
                            </Grid>
                        </Grid>
                        :
                        <Grid item>
                            <TCLabel >No Available Court</TCLabel>
                        </Grid>
                    }

                </Grid>
            }
        </Grid>
    )
}

const normalizeScheduleInfo = (scheduleInfo = []) => {
    return scheduleInfo.map(day => {
        let courtsInfo = (day.courtsInfo || []).map((courtInfo, index) => {
            return {
                ...courtInfo,
                _id: courtInfo._id || day.courts?.[index] || courtInfo.courtId || null,
                hours: courtInfo.hours || []
            }
        })

        return {
            ...day,
            courts: day.courts || courtsInfo.map(c => c._id).filter(Boolean),
            courtsInfo
        }
    })
}

export default ClassScheduleInfo